<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />
         <input-text
             class="mt-3"
            name="abbreviation"
            label="* Abbreviation"
            v-model="form.abbreviation"
            :error="errors.abbreviation ? errors.abbreviation[0] : null"
            :maxlength="255"
        />
        <input-text
             class="mt-3"
            name="symbol"
            label="* Symbol"
            v-model="form.symbol"
            :error="errors.symbol ? errors.symbol[0] : null"
            :maxlength="255"
        />

        <Select
            label="* Position of Symbol"
            name="position"
            v-model="form.position"
            class="mt-2"
            :options="[
                {value: 'before', name: 'Before the amount'},
                {value: 'after', name: 'After the amount'},
            ]"
            :error="errors.position ? errors.position[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "CurrencyForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                abbreviation: this.getFormData("abbreviation"),
                symbol: this.getFormData("symbol"),
                position: this.getFormData("position"),
            },
        };
    },
};
</script>
